<!-- Translated: yes -->
<template>
  <div class="back" @click="click">
    <span class="text">
      <icon name="arrow" :scale="1.2"></icon>
      {{ text ? text : $t('general.back') }}
    </span>
  </div>
</template>

<script>
import Back from '@/components/components/Back';

export default {
  props: ['clicked', 'text'],
  components: {
    Back,
  },
  methods: {
    click() {
      if (this.clicked) {
        this.clicked();
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'

.back
  background-color: pale-grey
  cursor pointer
  width 100%
  text-align left
  font-size 12px
  cursor pointer
  +min-tablet()
    background-color: pale-grey
    display inline-block
    border-radius: 3px
    padding: 17px 18px 14px;
    width: auto
    display inline-block
  .icon
    position: relative
    top: -1px
    margin-right: 7px
  +max-mobile()
    width 100%
    height 50px
    background-color #ecf5f8
    font-size: 14px
    padding: 17px 18px 14px;

  .text
    color deep-sea-blue
    font-size: 11px
    uppercase()
    font-weight 700
    +max-mobile()
      display block

</style>



// WEBPACK FOOTER //
// Back.vue?79ca5b58